"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _preactCompat = require("preact-compat");

var _AlertComponent = _interopRequireDefault(require("@insided/shared/uikit/AlertComponent"));

var _PrivateMessageTooltip = _interopRequireDefault(require("./more-options/PrivateMessageTooltip"));

var _ReportPrivateMessage = _interopRequireDefault(require("./more-options/ReportPrivateMessage"));

var _phrase = require("../../libs/translationsUtils/phrase");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'private-message';
exports.cssAnchorName = cssAnchorName;

var PrivateMessage = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(PrivateMessage, _PureComponent);

  var _super = _createSuper(PrivateMessage);

  function PrivateMessage(props) {
    var _this;

    (0, _classCallCheck2.default)(this, PrivateMessage);
    _this = _super.call(this, props);
    _this.setAlertMessage = _this.setAlertMessage.bind((0, _assertThisInitialized2.default)(_this));
    _this.unsetAlertMessage = _this.unsetAlertMessage.bind((0, _assertThisInitialized2.default)(_this));
    _this.showReportModal = _this.showReportModal.bind((0, _assertThisInitialized2.default)(_this));
    _this.hideReportModal = _this.hideReportModal.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  } // eslint-disable-next-line class-methods-use-this


  (0, _createClass2.default)(PrivateMessage, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var phrases;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                phrases = [{
                  module: 'Forum',
                  key: 'privateMessages.conversation.reportButton'
                }, {
                  module: 'Forum',
                  key: 'privateMessages.reportModal.title'
                }, {
                  module: 'Forum',
                  key: 'privateMessages.reportModal.reasons.placeholder'
                }, {
                  module: 'Forum',
                  key: 'privateMessages.reportModal.text'
                }, {
                  module: 'Forum',
                  key: 'privateMessages.reportModal.sender'
                }, {
                  module: 'Forum',
                  key: 'privateMessages.reportModal.message'
                }, {
                  module: 'Forum',
                  key: 'privateMessages.reportModal.reasons'
                }, {
                  module: 'Forum',
                  key: 'privateMessages.reportModal.reportButton'
                }, {
                  module: 'Forum',
                  key: 'privateMessages.reportModal.cancelButton'
                }, {
                  module: 'Forum',
                  key: 'privateMessages.reportModal.reasons.error'
                }, {
                  module: 'Forum',
                  key: 'privateMessages.reportModal.error'
                }, {
                  module: 'Forum',
                  key: 'privateMessages.reportSuccessModal.title'
                }, {
                  module: 'Forum',
                  key: 'privateMessages.reportSuccessModal.text'
                }, {
                  module: 'Forum',
                  key: 'privateMessages.reportSuccessModal.button'
                }];
                _context2.next = 3;
                return Promise.all(phrases.map( /*#__PURE__*/function () {
                  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(p) {
                    return _regenerator.default.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return new Promise(function (resolve) {
                              return (0, _phrase.fetchPhrase)(p.module, p.key, function (phrs) {
                                return resolve(phrs);
                              });
                            });

                          case 2:
                            return _context.abrupt("return", _context.sent);

                          case 3:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }()));

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "setAlertMessage",
    value: function setAlertMessage(message) {
      this.setState({
        alertMessage: message
      });
    }
  }, {
    key: "unsetAlertMessage",
    value: function unsetAlertMessage() {
      this.setState({
        alertMessage: undefined
      });
    }
  }, {
    key: "showReportModal",
    value: function showReportModal() {
      this.setState({
        showReportModal: true
      });
    }
  }, {
    key: "hideReportModal",
    value: function hideReportModal() {
      this.setState({
        showReportModal: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          messageId = _this$props.messageId,
          messageContent = _this$props.messageContent,
          userId = _this$props.userId,
          conversationUser = _this$props.conversationUser,
          canReport = _this$props.canReport,
          canDelete = _this$props.canDelete,
          phrases = _this$props.phrases;
      var _this$state = this.state,
          alertMessage = _this$state.alertMessage,
          showReportModal = _this$state.showReportModal;
      var showTooltip = canReport || canDelete;
      return (0, _preact.h)("div", null, alertMessage && (0, _preact.h)(_AlertComponent.default, {
        sticky: true,
        isVisibleFor: 3000,
        onTimeoutEnd: this.unsetAlertMessage
      }, alertMessage), showTooltip && (0, _preact.h)(_PrivateMessageTooltip.default, {
        messageId: messageId,
        messageContent: messageContent,
        userId: userId,
        conversationUser: conversationUser,
        canDelete: canDelete,
        setAlertMessage: this.setAlertMessage,
        phrases: phrases,
        onReport: this.showReportModal
      }), showReportModal && (0, _preact.h)(_ReportPrivateMessage.default, {
        messageId: messageId,
        messageContent: messageContent,
        userId: userId,
        conversationUser: conversationUser,
        setAlertMessage: this.setAlertMessage,
        hideReportModal: this.hideReportModal
      }));
    }
  }]);
  return PrivateMessage;
}(_preactCompat.PureComponent);

var _default = PrivateMessage;
exports.default = _default;